module.exports = __webpack_public_path__ + "img/MQ.54b0c5e0.svg";